module.exports = __webpack_public_path__ + "static/img/jigou.d385d294.png";